export default "__VITE_ASSET__kLY5kPnT__"